import store from '@/store'
import { userPermissionsConfig$, DSPUserPermissionsConfig } from '@/shared-services'

/**
 * @param {Array} value
 * @returns {Boolean}
 */
export default function checkPermission(value) {
  if (value && value instanceof Array && value.length > 0) {
    const roles = store.getters && store.getters['user/role']
    const permissionRoles = value

    // const hasPermission = roles.some(role => {
    //   return permissionRoles.includes(role)
    // })
    return permissionRoles.includes(roles)
  } else {
    console.error(`need roles! Like v-permission="['admin','editor']"`)
    return false
  }
}


export function reassginOwner(data) {
  userPermissionsConfig$.subscribe(x => {
    x.changePopupDialog({isShow: true, ...data})
  })
}

export function DSPNoPermissionFilterItemFn(key) {
  return DSPUserPermissionsConfig.DSPNoPermissionFilterItem(key)
}
export function DSPFilterNoPermissionIdFn(id) {
  return DSPUserPermissionsConfig.DSPFilterNoPermissionId(id)
}
export function DSPMakeOutgoingCallFn(obj) {
  return DSPUserPermissionsConfig.DSPMakeOutgoingCall(obj)
}
export function noPermissionSettings(key, id, systemSource) {
  if (store.state.user.systemSourceOrigin === "fleet") {
    let usersAuthoritiesFlag, systemSourceFlag, idFlag;
    usersAuthoritiesFlag = store.state.user.usersAuthorities[key] === "view" || store.state.user.usersAuthorities[key] === "false";
    if (systemSource) {
      systemSourceFlag = systemSource === "dispatcher";
      if(systemSourceFlag && usersAuthoritiesFlag) {
        return true;
      } else {
        return false;
      }
    }
    if(id) {
      idFlag = store.state.user.userId !== id;
      if (usersAuthoritiesFlag && idFlag) {
        return true;
      } else {
        return false;
      }
    }
    if(usersAuthoritiesFlag) return true;
    return false;
  }
}